var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',{attrs:{"include":"QuickNav"}},[_c(_vm.currentComponents,{tag:"component",on:{"toggle":_vm.toggle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }